import Image from 'next/image'
import Link from 'next/link'

import { VIDEOS_TEST_IDS } from '../../videos.const'
import type { AcademyVideo } from '../../videos.interface'

import styles from './AcademyVideoCard.module.scss'

type AcademyVideoCardProps = {
  video: AcademyVideo
}

export function AcademyVideoCard({ video }: AcademyVideoCardProps) {
  const topicLabel = video.primaryTopicLabel ?? ''

  return (
    <Link href={`/videos/${video.slug}`} className={styles.card} data-testid={VIDEOS_TEST_IDS.videoCard}>
      <div className={styles.thumbnail}>
        <Image
          src={video.thumbnailUrl}
          alt=""
          fill
          className={styles.thumbnailImage}
          sizes="(min-width: 64rem) 50vw, 100vw"
          unoptimized={video.thumbnailUrl.startsWith('https://')}
        />
      </div>
      <div className={styles.content}>
        <p className={styles.title}>{video.title}</p>
        <div className={styles.meta}>
          {topicLabel ? <span className={styles.topic}>{topicLabel}</span> : <span />}
          <span className={styles.duration}>{video.duration}</span>
        </div>
      </div>
    </Link>
  )
}
